import React, { useState } from 'react';
import DropdownMultiSelect from '../DropdownMultiSelect/index.js';
import './style.scss';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon/index.js';
import FullScreenConfirmDialog from '../FullScreenConfirmDialog/FullScreenConfirmDialog.jsx';
import { useTranslation } from 'react-i18next';

const SectionItemMultiselectFilter = ({option, onOptionChange, optionKey}) => {
  const rootState = useSelector(state => state);
  const items = (option.mappingLambda ? option.mappingLambda(rootState) : option.items) || [];

  return (
    <div className={'sectionItemMultiselect'}>
      <div className={classNames('title')}>{option.label || ''}</div>
      <DropdownMultiSelect
        values={items}
        selectedValues={option.selected || []}
        onApply={item => onOptionChange(optionKey, 'selected', item)}
        placeholderEmpty={option.label || ''}
        placeholderMulti={option.label || ''}
      />
    </div>
  );
};

const SectionItemEditMultiselect = ({column, onPropChange, value, item}) => {
  const rootState = useSelector(state => state);
  const items = (column.connect ? (column.connect(rootState)?.values || []) : column.items) || [];

  return (
    <div className={'sectionItemMultiselect sectionItemEditMultiselect'}>
      <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
      <DropdownMultiSelect
        values={items}
        selectedValues={value || []}
        onApply={item => onPropChange({ [column.accessor]: item })}
        placeholderEmpty={''}
        placeholderMulti={column.placeholder || ''}
      />
    </div>
  );
}

const SectionItemMultiselect = ({ filter, optionKey, option, onOptionChange, column, onPropChange, value, item, ...rest }) => {
  const [isShow, setShow] = useState(false);
  const [valueData, setValueData] = useState(null);
  const {t} = useTranslation();

  const handleOnChange = (value) => {
    if(column?.showWarnOnChange?.(value)) {
      setValueData(value);
      setShow(true);
      return;
    }
    onPropChange(value);
  }

  const handleOnCancel = () => {
    setShow(false);
    setValueData(null);
  }

  const handleOnConfirm = () => {
    onPropChange(valueData);
    setShow(false);
    setValueData(null);
  }

  return (
    <>
      {isShow && (
        <FullScreenConfirmDialog 
          t={t} 
          useWrapperClass={"sectionItemSelectWarningMessage"}
          handleOnConfirm={handleOnConfirm} 
          handleOnCancel={handleOnCancel}
          description={t("enums.campaign.SMS_WARNING")}
          cancelText={t("basic.CANCEL_BUTTON")}
          confirmText={t("basic.PROCEED_CONFIRM_MODAL")}
        />
      )}
      {!!filter && <SectionItemMultiselectFilter option={option} onOptionChange={onOptionChange} optionKey={optionKey} />}
      {!filter && <SectionItemEditMultiselect item={item} column={column} onPropChange={handleOnChange} value={value} />}
    </>
  )
};

export default SectionItemMultiselect;
